import { useEffect } from "react";
import { gtag } from "../utils/util";
import { API_ENDPOINT, APP_ID } from "../utils/constants";
import { getDbHeader } from "../utils/util";

function GtagLoader() {
  useEffect(() => {
    async function initializeGtag() {
      try {
        // 1. Fetch gtag configuration from API
        const response = await fetch(`${API_ENDPOINT}event/get-gtag-config`, {
          ...getDbHeader(APP_ID),
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();

        // 2. Validate and extract tracking IDs
        const trackingId = data?.gtag?.trackingId;
        const gtmId = data?.gtag?.gtmId;

        if (!trackingId || typeof trackingId !== "string") {
          throw new Error("Invalid or missing tracking ID");
        }

        // 3. Initialize data layer
        window.dataLayer = window.dataLayer || [];

        // 4. Define gtag function if it doesn't exist
        window.gtag =
          window.gtag ||
          function () {
            window.dataLayer.push(arguments);
          };

        // 5. Load the gtag.js script
        const gtagScript = document.createElement("script");
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        gtagScript.async = true;

        gtagScript.onload = () => {
          console.log(`GTag loaded successfully for ID: ${trackingId}`);
        };

        gtagScript.onerror = () => {
          throw new Error("Failed to load gtag.js script");
        };

        document.head.appendChild(gtagScript);

        // 6. Initialize gtag with configuration
        window.gtag("js", new Date());
        window.gtag("config", trackingId, {
          ...(data.gtag.additionalConfig || {}),
          send_page_view: false, // Keep this as false since GtagRouterTracker handles page views
        });

        // 7. Add GTM script if gtmId exists
        if (gtmId && typeof gtmId === "string") {
          // GTM script
          const gtmScript = document.createElement("script");
          gtmScript.async = true;
          gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

          gtmScript.onload = () => {
            console.log(`GTM loaded successfully for ID: ${gtmId}`);
          };

          gtmScript.onerror = () => {
            throw new Error("Failed to load GTM script");
          };

          document.head.appendChild(gtmScript);

          // GTM noscript (for browsers with JavaScript disabled)
          const gtmNoscript = document.createElement("noscript");
          const iframe = document.createElement("iframe");
          iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
          iframe.height = "0";
          iframe.width = "0";
          iframe.style.display = "none";
          iframe.style.visibility = "hidden";

          gtmNoscript.appendChild(iframe);
          document.body.appendChild(gtmNoscript);
        }
      } catch (error) {
        console.error("GTag/GTM initialization error:", error.message);
      }
    }

    initializeGtag();

    return () => {
      // Cleanup logic if needed
    };
  }, []);

  return null;
}

export default GtagLoader;
